import { Icon, IconProps, PropsOf } from "@chakra-ui/react";
import { memo } from "react";
import { IconType } from "react-icons";

export default memo(function ({ ...iconProps }: PropsOf<IconType> & IconProps) {
  return <Icon position={"absolute"} {...iconProps} />;
});
